import type { AgentPersona } from "./types"

export const genericPersona: AgentPersona = {
  id: "generic",

  systemPrompt:
    "You are a helpful assistant for this app. Use the available tools to help the user accomplish their goals. Always confirm before destructive actions.",

  greeting: "Hi! I can help you navigate this app.",

  toolFilter: () => true,
}
